var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHdri(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9997 18.5556V55.1111C50.9997 57.5585 49.8331 59 48.3331 59H5.66665C4.16666 59 3 57.5585 3 55.1111V7.07895C3 4.63158 4.83332 3 6.33331 3H32.9998C33.9998 3 35.3077 3.72881 35.7084 4.09131L35.8753 4.24058L49.9997 16.6111C50.3331 17 50.9997 17.7778 50.9997 18.5556Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.0006 18.5528V28.664L38.334 18.5528L35.334 3.77507L50.0006 16.6084C50.3339 16.9973 51.0006 17.7751 51.0006 18.5528Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.334 3.77507L38.334 18.5528L50.0006 16.6084L35.334 3.77507Z",
    fill: "#838383"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3486 35.5772H16.7406V31.5572H20.5206V35.5772H21.9126V26.7332H20.5206V30.3452H16.7406V26.7332H15.3486V35.5772Z",
    fill: "#A8A8A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4714 35.5772H26.8354C29.4754 35.5772 31.0234 33.9932 31.0234 31.1252C31.0234 28.2452 29.4754 26.7332 26.7634 26.7332H24.4714V35.5772ZM25.8634 34.4372V27.8732H26.6674C28.5634 27.8732 29.5834 28.9172 29.5834 31.1252C29.5834 33.3212 28.5634 34.4372 26.6674 34.4372H25.8634Z",
    fill: "#A8A8A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1021 35.5772H34.4941V32.0132H35.9221L37.9261 35.5772H39.4981L37.3381 31.8332C38.4541 31.4852 39.1861 30.6692 39.1861 29.3012C39.1861 27.3932 37.8181 26.7332 35.9941 26.7332H33.1021V35.5772ZM34.4941 30.8972V27.8612H35.8261C37.1101 27.8612 37.8061 28.2332 37.8061 29.3012C37.8061 30.3692 37.1101 30.8972 35.8261 30.8972H34.4941Z",
    fill: "#A8A8A8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdri);
export default __webpack_public_path__ + "static/media/hdri.53e6381e7665f53f4c95bc4593dc0816.svg";
export { ForwardRef as ReactComponent };